import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"


import QrcodeVue from "qrcode.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'QRToken',
  props: {
    token: {}
  },
  setup(__props: any) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(QrcodeVue, {
    value: props.token,
    size: 300,
    margin: 1
  }, null, 8, ["value"]))
}
}

})